var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" MEDICO LEGAL CASE ")]),_c('h4',[_vm._v(" Any injury or medical condition resulting from, incidental to, or involving any act of omission of a third party, such as but not limited to crimes, quasi-delicts (fault or negligence in an act or omission which causes damage) and vehicular accidents. ")])])
}]

export { render, staticRenderFns }